import * as React from "react";

const InitialSearchIcon = (props) => (
    <svg width="258" height="218" viewBox="0 0 258 218" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="109" cy="109" r="99" fill="#E1ECF7" fillOpacity="0.5" stroke="white" strokeWidth="20" />
        <rect x="46" y="106" width="101" height="10" rx="2" fill="#DAE3EF" />
        <rect x="10" y="106" width="32" height="10" rx="2" fill="#DAE3EF" />
        <rect x="64" y="76" width="83" height="10" rx="2" fill="#DAE3EF" />
        <rect x="10" y="76" width="50" height="10" rx="2" fill="#DAE3EF" />
        <rect x="83" y="136" width="64" height="10" rx="2" fill="#DAE3EF" />
        <rect x="10" y="136" width="68" height="10" rx="2" fill="#DAE3EF" />
        <rect x="66" y="166" width="81" height="10" rx="2" fill="#DAE3EF" />
        <rect x="10" y="166" width="51" height="10" rx="2" fill="#DAE3EF" />
        <circle cx="154" cy="66" r="43.5" fill="#E1ECF7" stroke="#333F50" strokeWidth="7" />
        <rect x="112" y="65" width="35" height="21" rx="2" fill="#C0CFE4" />
        <path d="M193.529 72.7729C189.684 94.5271 168.932 109.045 147.178 105.2C147.178 105.2 172.803 91.5434 176.648 69.7892C180.493 48.035 161.102 26.4215 161.102 26.4215C182.856 30.2665 197.374 51.0187 193.529 72.7729Z" fill="white" />
        <path d="M210.956 133.513L205.678 122.922L210.956 117.422L222.27 122.2L257.625 157.555L246.311 168.869L210.956 133.513Z" fill="#333F50" />
        <path d="M183.5 95.5L215 127L246.5 158.5" stroke="#333F50" strokeWidth="8" />
        <circle cx="154" cy="66" r="43.5" stroke="#333F50" strokeWidth="7" />
    </svg>
);

export default InitialSearchIcon;
